export const isDevelopment = import.meta.env.MODE === 'development';

export const isIntegration = import.meta.env.MODE === 'integration';

export const isTestEnvironment = isDevelopment || isIntegration;
